import SmoothScroll from 'smooth-scroll';
const smoothScroll = new SmoothScroll();

class ScrollTo {

    constructor(el) {
        this.el = el;
        this.target = document.querySelector(el.getAttribute('href'));
        if(this.target != null) {
            this.el.onclick = (e) => {
                e.preventDefault();
                smoothScroll.animateScroll(
                    this.target,
                    e.currentTarget,
                    {
                        speed: 1000,
                        easing: 'easeInOutQuad'
                    }
                );
            };
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ScrollTo(node);
        }
    });
}